import { withWidth } from '@material-ui/core';
import { compose } from 'recompose';
import withTranslations from '%app/js/common/components/translation/withTranslations';
import StyledTable from './StyledTable';

export default compose(
    withWidth(),
    withTranslations(['PayseraAdminBundle']),
)(StyledTable);
